/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react';
import PreviewModal from '@/components/PreviewModal'
import { Table, Button, Select, Divider, Popconfirm, Card, Modal } from 'antd'
import styles from './index.less'
import moment from 'moment'
import ScanCodePayment from './ScanCodePayment';
import {
  ORDER_STATUS_PAID,
  ORDER_STATUS_PART_PAY,
  ORDER_STATUS_TO_PAY,
  PAY_METHOD_MAP,
  PAYMENT_METHOD_MAP,
  PAYMENT_TYPE_IN_COLLECTION_OBJ,
  ORDER_STATUS_TO_CONFIRM,
  ORDER_STATUS_SUCCESS,
  ORDER_REFUNT_STATUS_FULL_REFUND,
  PAYMENT_STATUS,
  PAYMENT_METHOD_SHOW
} from '@/utils/consts';

const { Option } = Select

const ReceivablesInfo = ({ info, status, onRefundEdit, source, payments, pagination, onChange, onEdit, onDelete, continuePay, onCancelPayment, loading }) => {

  const [visible,setVisible] = useState(false);
  const [imgUrl,setImgUrl] = useState([]);

  const columns = [
    {
      dataIndex: 'receiptDate',
      title: '收款日期',
      width: 85,
      render(text) {
        return moment(text).format('YYYY-MM-DD')
      }
    },
    {
      dataIndex: 'paymentCategory',
      title: '收款方式',
      width: 75,
      render:text => PAYMENT_TYPE_IN_COLLECTION_OBJ[text]
    },
    // {
    //   dataIndex: 'payMethod',
    //   title: '付费习惯',
    //   width: 100,
    //   render: payMethod => PAY_METHOD_MAP[payMethod]
    // },
    {
      dataIndex: 'paymentMethod',
      title: '支付类型',
      width: 80,
      render: paymentMethod => PAYMENT_METHOD_SHOW[paymentMethod]
    },
    {
      key:"classification",
      dataIndex:'classification',
      title:'分类',
      width:50,
      align:'center',
      render:(text)=>{
        return text&&{none:'无',first:'新签',renew:'续费'}[text];
      }
    },
    {
      dataIndex: 'amount',
      title: '本次收款金额',
      align: 'right',
      width: 90,
      render: (amount) => amount&&amount.toFixed(2) + "元"
    },
    {
      dataIndex: 'status',
      title: '支付状态',
      width: 90,
      align:'center',
      render: (status) => status&&PAYMENT_STATUS[status]
    },
    // {
    //   dataIndex: 'unpaidSum',
    //   title: '剩余待缴费金额',
    //   // width: 80,
    // },
    {
      dataIndex: 'financialConfirmer',
      title: '财务确认人',
      width: 90,
      align: 'center',
    },
    {
      dataIndex:'attachment',
      key:'attachment',
      title:'收款凭证',
      width:80,
      render:(text)=>{
        return  <Button type="link" disabled={text?false:true} onClick={()=>{setVisible(true);let temp = (text&&text.split(','))||[];setImgUrl(temp)}}>查看</Button>
      }
    },
    {
      dataIndex: 'comment',
      title: '备注',
      ellipsis: true,
      width:50
    },
    {
      dataIndex: 'createdAt',
      title: '创建时间',
      width:90,
      render:(text)=>{
        return text&&moment(text).format('YYYY-MM-DD')
      }
    },
    {
      dataIndex: 'action',
      title: '操作',
      align:'center',
      width:150,
      render:(text,record)=>{
        return source !== 'task'&&<span style={{whiteSpace:'nowrap'}}>
          {/* 待支付 */}
          {record.status === ORDER_STATUS_TO_PAY&&
            <>
              <Popconfirm
                title="确认取消此次支付吗?"
                onConfirm={()=>{onCancelPayment&&onCancelPayment(record)}}
                okText="是"
                cancelText="否"
              >
                <a >取消</a>
              </Popconfirm>
              <Divider type="vertical"/>
              <a onClick={()=>{ continuePay&&continuePay(record) }} >继续支付</a>  
            </>
          }
          {/* 支付中 */}
          {record.status === 'paying'&&
          <Popconfirm
          title="确认取消此次支付吗?"
          onConfirm={()=>{onCancelPayment&&onCancelPayment(record)}}
          okText="是"
          cancelText="否"
        >
          <a >取消</a>
        </Popconfirm>
        }
          {/* 已支付 */}
          {record.status === ORDER_STATUS_SUCCESS&&
            <>
              <a disabled={status === ORDER_STATUS_TO_CONFIRM || status === ORDER_STATUS_SUCCESS || status === ORDER_STATUS_TO_PAY || info.refundStatus === ORDER_REFUNT_STATUS_FULL_REFUND} onClick={()=>{ onRefundEdit('add', { customerName: info.customerName, customerId: info.customerId, createdByUser: info.createdByUser },undefined,record)}}>线下退款</a>
              {record.paymentCategory === 'online_payment'&&
                <>
                  <Divider type="vertical"/>
                  <a disabled={status === ORDER_STATUS_TO_CONFIRM || status === ORDER_STATUS_SUCCESS || status === ORDER_STATUS_TO_PAY || info.refundStatus === ORDER_REFUNT_STATUS_FULL_REFUND} onClick={()=>{ onRefundEdit('add', { customerName: info.customerName, customerId: info.customerId, createdByUser: info.createdByUser }, 'online',record)}}>线上退款</a>  
                </>
              }
              </>
          }
          
          
        </span>
      }
    },
    // {
    //   dataIndex: 'operation',
    //   title: '操作',
    //   width: 120,
    //   align: 'center',
    //   render(text, record) {
    //     if ([ORDER_STATUS_TO_PAY, ORDER_STATUS_PART_PAY, ORDER_STATUS_PAID].indexOf(status) === -1) return null;
    //     if(source === 'task') return null 
    //     return (
    //       <Fragment>
    //         <a href="javascript:void(0);" onClick={() => onEdit('update', record)}>编辑</a>
    //       </Fragment>
    //     );
    //   }
    // }
  ]

  return (
    <div className={styles.reserve}>
      <Card title='收款信息' size='small' style={{marginTop: 10}} bordered={false}>
      <Table
        columns={columns}
        dataSource={payments}
        pagination={false}
        defaultExpandAllRows={true}
        loading={loading&&loading.effects['orderList/queryPayments']}
        // scroll= {{ x: 1150 }}
        expandedRowRender={expandedRowRender}
        expandIcon={({expanded, onExpand, record}) => record.orderItemPaymentVoList ? <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse' } onClick={onExpand} /></span> : null}
        size="small"
        rowKey="id"
      />
      </Card>
      {/* <Modal
        visible={visible}
        title='收款凭证'
        footer={null}
        onCancel={()=>{setVisible(false);setImgUrl([])}}
      >
        {imgUrl&&imgUrl.map((item)=>{
          return <img style={{width:'100%'}} src={item} alt='收款凭证'/>
        })}

      </Modal> */}
      <PreviewModal 
        visible={visible} 
        onCancel={()=>{setVisible(false);setImgUrl([])}}
        imgArray={imgUrl}
        title='收款凭证'
      />
    </div>
  )
}

export default ReceivablesInfo

function expandedRowRender(record) {
  const columns = [
    // {
    //   title: '商品类别',
    //   key: 'productCategoryName',
    //   render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    // },
    {
      title: '商品名称',
      dataIndex: 'name',
    },
    // {
    //   title: '服务频次',
    //   dataIndex: 'productVo',
    //   width: 80,
    //   align: 'right',
    //   render: (product, record) => (product || {}).quantity
    // },
    {
      title: '商品原价',
      dataIndex: 'price',
      width: 100,
      align: 'right',
      render: (price) => price && price > 0 ? price + '元' : undefined
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      width: 80,
      align: 'right',
    },
    {
      title: '折扣',
      dataIndex: 'discount',
      width: 100,
      align: 'right',
      render: discount => discount && discount <= 1 ? Number(discount * 100).toFixed(2) + '%' : undefined
    },
    // {
    //   title: '折后金额',
    //   dataIndex: 'discountPrice',
    //   width: 100,
    //   align: 'right',
    //   render: (discountPrice) => discountPrice && discountPrice >= 0 ? discountPrice + '元' : undefined
    // },
    // {
    //   title: '折后立减',
    //   dataIndex: 'couponPrice',
    //   width: 100,
    //   align: 'right',
    //   render: (couponPrice) => couponPrice && couponPrice > 0 ? couponPrice + '元' : '0.00元'
    // },
    {
      title: '单项收款',
      dataIndex: 'actualAmount',
      width: 100,
      align: 'right',
      render: (actualAmount) => actualAmount && actualAmount > 0 ? actualAmount + '元' : undefined
    },
    {
      title: '分摊实收明细',
      dataIndex: 'realAmount',
      width: 100,
      align: 'right',
      render: (realAmount) => realAmount && realAmount > 0 ? realAmount + '元' : undefined
    },
    {
      title: '剩余应收',
      dataIndex: 'remainingAmount',
      width: 100,
      align: 'right',
    },
    {
      title: '本次实收',
      dataIndex: 'amount',
      width: 100,
      align: 'right',
    },
  ]

  if(record.orderItemPaymentVoList) {
    return (
    <Fragment>
      <h4 className='order-items-label'>收款明细</h4>
      <Table columns={columns} pagination={false} bordered={false} dataSource={record.orderItemPaymentVoList || []} size='small'/>
    </Fragment>)
  }else {
    return false
  }
};